import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import WorldMap from "../WorldMap/WorldMap";
import './LandingPage.css';

function LandingPage({ scrollToMap }) {
  // const mapRef = useRef(null);

  // useEffect(() => {
  //   if (scrollToMap && mapRef.current) {
  //     mapRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [scrollToMap]);

  return (
    <div className="landing_page">
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ height: "80vh" }}
      >
        <div className="ms-3" style={{ width: "50%" }}>
          <div
            style={{
              backgroundColor: "#4169e1", // Blue box
              color: "white",
              padding: "20px",
              borderRadius: "10px",
              marginBottom: "20px",
            }}
          >
            <strong>Stockastix</strong> is a tool designed to:
            <ul>
              <li>Help make informed trading decisions</li>
              <li>Know when to buy and sell stocks</li>
              <li>Back up your decisions with data</li>
              <li>Use data-driven analysis to assess stocks on several factors</li>
              <li>Trade with confidence and control risks</li>
            </ul>
          </div>
          <div
            style={{
              backgroundColor: "#ffa500",
              color: "black",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <strong>Capabilities:</strong>
            <ul>
              <li>Backtesting of stocks</li>
              <li>Comparative analysis of stocks</li>
              <li>Trading BOT</li>
              <li>Assessment and analysis of stocks</li>
            </ul>
          </div>
        </div>

        <div
          className="me-3 text-center"
          style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <h1
              style={{
                fontSize: "120px",
                fontWeight: "bold",
                color: "#fff",
              }}
            >
              Stockasti<span style={{ color: "var(--green)" }}>x</span>
            </h1>
            <p
              style={{
                fontSize: "20px",
                color: "#aaa",
              }}
            >
              The Smart Way to Trade.
            </p>
          </div>
        </div>
      </div>
      {/* <div ref={mapRef}>
        <WorldMap />
      </div> */}
    </div>
  );
}

export default LandingPage;
